// A URL é definida pelo React ao iniciar o servidor ou gerar o build.
export const API_BASE_URL = (
  process.env.REACT_APP_BACKEND_URL || "http://localhost/api"
)
  .trim()
  .replace(/\/+$/, "");

// Os módulos publicados usavam /api/. A base configurada já contém essa pasta.
export function getApiUrl(endpoint = "", baseUrl = API_BASE_URL) {
  if (/^https?:\/\//i.test(endpoint)) return endpoint;
  const base = baseUrl.trim().replace(/\/+$/, "");
  const resource = String(endpoint)
    .replace(/^\/+/, "")
    .replace(/^api(?:\/|$)/, "");
  return resource ? base + "/" + resource : base + "/";
}
